import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-p-small', 'LetterPSmall', [["path",{"d":"M10 12h2a2 2 0 1 0 0 -4h-2v8","key":"svg-0"}]]);